type RadioColor = "primary" | "danger" | "success2" | "dark-blue" | "black";

/**
 * Style props for radio input fields
 * @property {RadioColor} [ringColor] - Radio button ring color
 * @property {RadioColor} [checkedColor] - Radio button checked color
 * @property {("sm" | "md" | "lg")} [size] - Radio button size
 * @property {string} [className] - Additional Tailwind classes
 */
export interface RadioInputStyleProps {
  ringColor?: RadioColor;
  checkedColor?: RadioColor;
  size?: "sm" | "md" | "lg";
  className?: string;
}

export interface RadioInputLayoutStyleProps {
  className?: string;
}

export const defaultRadioInputStyles: Required<
  Omit<RadioInputStyleProps, "className">
> = {
  ringColor: "black",
  checkedColor: "black",
  size: "md",
};

export const radioInputStylesMap = {
  size: {
    sm: "w-3 h-3 before:w-3 before:h-3",
    md: "w-4 h-4 before:w-4 before:h-4",
    lg: "w-5 h-5 before:w-5 before:h-5",
  },
  ringColor: {
    primary: "ring-primary",
    danger: "ring-danger2",
    success2: "ring-success2",
    "dark-blue": "ring-dark-blue",
    black: "ring-black",
  },
  checkedColor: {
    primary: "before:bg-primary",
    danger: "before:bg-danger2",
    success2: "before:bg-success2",
    "dark-blue": "before:bg-dark-blue",
    black: "before:bg-black",
  },
} as const;
